__turbopack_context__.v({
  "down": "styles-module__ETbEuG__down",
  "dpad": "styles-module__ETbEuG__dpad",
  "dpadButton": "styles-module__ETbEuG__dpadButton",
  "dpadCenter": "styles-module__ETbEuG__dpadCenter",
  "left": "styles-module__ETbEuG__left",
  "right": "styles-module__ETbEuG__right",
  "swipePad": "styles-module__ETbEuG__swipePad",
  "up": "styles-module__ETbEuG__up",
});
